import { render, staticRenderFns } from "./MatchPage.vue?vue&type=template&id=009f7505&scoped=true&"
import script from "./MatchPage.vue?vue&type=script&lang=js&"
export * from "./MatchPage.vue?vue&type=script&lang=js&"
import style0 from "./MatchPage.vue?vue&type=style&index=0&id=009f7505&scoped=true&lang=css&"
import style1 from "./MatchPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f7505",
  null
  
)

export default component.exports